import { useQuery } from "@tanstack/react-query";
import systemApi from "@/api/systemApi";

export function useApiVersionQuery() {
    return useQuery({
        queryKey: ["apiVersion"],
        queryFn: () => systemApi.getApiVersion(),
        staleTime: 5 * 60 * 1000, // 5 minutes
        refetchOnWindowFocus: false,
        retry: 2,
        retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000), // Exponential backoff up to 30 seconds
    });
}    